export const STAFF_ROLES = [
    // { label: 'Head Conductor', value: 'Head Conductor' },
    { label: 'Conductor', value: 'Conductor' },
    { label: 'Night Conductor', value: 'Night Conductor' },
    { label: 'Steward', value: 'Steward' },
    { label: 'Maitre', value: 'Maitre' },
    { label: 'Head Barman', value: 'Head Barman' },
    { label: 'Barman', value: 'Barman' },
    { label: 'Waiter', value: 'Waiter' },
    { label: 'Head Chef', value: 'Head Chef' },
    { label: 'Sous Chef', value: 'Sous Chef' },
    { label: 'Dishwasher', value: 'Dishwasher' },
    { label: 'Guest Relations Executive', value: 'GuestRelationsExecutive' },
]